















import Vue, { PropType } from 'vue';
import { Icon } from '@/components/ds';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    images: {
      type: Array as PropType<String[]>,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    // os tipos de retorno são explícitos porque, sem eles, o TS não consegue fechar a
    // inferência de `this` entre os dois computeds e passa a resolver `this.images`
    // como ComputedOptions em vez da prop
    currentImg(): String {
      return this.images[(this as any).currentCount];
    },
    currentCount(): number {
      return Math.abs(this.$data.currentIndex) % this.images.length;
    },
  },
  methods: {
    next() {
      this.$data.currentIndex++;
    },
    prev() {
      this.$data.currentIndex--;
    },
  },
});
